import {
  ComponentTypes,
  OrganizationSchemaBlock,
} from '@fdc/repositories/content-repository';

export const ORGANIZATION_SCHEMA_BLOCK: OrganizationSchemaBlock = {
  __typename: ComponentTypes.ORGANIZATION_SCHEMA,
  data: {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    '@id': 'https://www.woolworths.co.nz',
    name: 'Woolworths New Zealand',
    url: 'https://www.woolworths.co.nz',
    logo: 'https://s7ap1.scene7.com//is/image/woolworthsgroupmrm/LOGO_WOOLWORTHS_NZ_FY25?fmt=png-alpha',
    sameAs: [
      'https://www.facebook.com/woolworthsnewzealand',
      'https://www.pinterest.nz/woolworths_nz',
      'https://www.linkedin.com/company/woolworths-new-zealand',
      'https://www.youtube.com/@woolworths_nz',
      'https://www.instagram.com/woolworths_nz/',
    ],
    contactPoint: [
      {
        '@type': 'ContactPoint',
        telephone: '+64 0800 40 40 40',
        contactType: 'Customer Service',
        areaServed: 'New Zealand',
      },
    ],
    address: {
      '@type': 'PostalAddress',
      streetAddress: '80 Favona Road',
      addressLocality: 'Mangere',
      addressRegion: 'Manukau',
      postalCode: '2024',
      addressCountry: 'NZ',
    },
  },
};
